export enum XpassProductLabels {
  STRESS_FREE = 'Stress Free',
  GOVT_FEE = 'Govt Fee',
  CONCIERGE = 'Concierge'
}
